<app-ai-assist-shell
  [source]="source()"
  [modes]="modes"
  [isLoading]="isLoading()"
  [hasResult]="hasResult()"
  [disabledActions]="disabledActions()"
  [isSourceEmpty]="isSourceEmpty()"
  [hasLinkedContext]="hasLinkedContext()"
  (sourceChange)="onSourceChange($event)"
  (generate)="onGenerate($event)"
  (tryAgain)="onTryAgain()"
>
  <ng-template #aiAssistResult>
    @if (suggestion(); as currentSuggestion) {
      @if (currentSuggestion.title) {
        <div class="ai-assist-section-label">{{ 'field.title' | translate }}</div>
        <div class="ai-assist-preview ai-assist-preview-title">
          <div class="ai-assist-preview-scroll">{{ currentSuggestion.title }}</div>
        </div>
      }
      @if (currentSuggestion.description) {
        <div class="ai-assist-section-label">{{ 'field.description' | translate }}</div>
        <div class="ai-assist-preview">
          <div class="ai-assist-preview-scroll">{{ currentSuggestion.description }}</div>
        </div>
      }
    } @else if (report(); as currentReport) {
      <app-ai-report-view [report]="currentReport" />
    }
  </ng-template>
  <ng-template #aiAssistResultActions>
    @if (suggestion()) {
      <button mat-flat-button type="button" (click)="onApply()">
        <mat-icon>check</mat-icon>
        {{ 'page.artificialIntelligence.assistDialog.apply' | translate }}
      </button>
    } @else {
      <!-- Nothing to apply: a report is only read, or kept on the item as a comment. -->
      <button matButton="tonal" type="button" mat-dialog-close [disabled]="isAddingComment()">
        {{ 'button.close' | translate }}
      </button>
      @if (report(); as currentReport) {
        @if (itemId !== null) {
          <app-ai-report-comment-button
            [itemId]="itemId"
            [report]="currentReport"
            (commentAdded)="reportCommentAdded.emit()"
          />
        }
      }
    }
  </ng-template>
</app-ai-assist-shell>
